// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[3].use[2]!../../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!components/ui/common.module.scss");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
exports.push([module.id, ".df95df{font-size:.9375em;display:grid;gap:2em}.df95df>:nth-child(2){margin-top:-0.5em}._387f80{gap:2em;align-items:flex-end}._387f80 p+small{margin-top:.5em;display:block}._413430{display:flex;justify-content:space-between;flex-wrap:wrap}.b42ec5{margin-top:.25em;display:grid;grid-template-columns:1fr 1fr 1fr 1fr 1fr 1fr;gap:.5em .75rem}.b42ec5 button{justify-content:flex-start}.c3dade{margin-top:.25em;display:flex;flex-wrap:wrap;gap:4px;font-weight:600}.c3dade>button{text-align:center;width:2.5em;padding:.5em 0 !important}._3ffd15{margin-top:.5em;font-size:.9375em}._59ed5f~span{display:none}._59ed5f svg{color:var(--danger)}", ""]);
// Exports
exports.locals = {
	"popup": "df95df",
	"begin-end": "_387f80",
	"beginEnd": "_387f80",
	"weekdays": "_413430 " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["small-spacing"] + "",
	"months": "b42ec5",
	"days": "c3dade",
	"date-picker": "_3ffd15",
	"datePicker": "_3ffd15",
	"error": "_59ed5f"
};
module.exports = exports;
